/**
 * Строит идентификатор уведомления о звонке. Ключ — нормализованный телефон
 * (только цифры), поэтому один и тот же номер всегда даёт один и тот же id.
 * Отсюда и дедуп карточек, и адресное гашение тоста по терминальному событию.
 *
 * @param phone - телефон, только цифры (см. `formatPhoneNumber`)
 * @returns идентификатор уведомления вида `call-79184827011`
 */
export const buildCallNotificationId = (phone: string): string =>
  `call-${phone}`;
